import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { CHECKOUT_CONSTANTS } from 'common/constants/SharedConstants';
import {
  getAndCheck,
  getTernaryValue,
  isDeliveryDisposition,
  isDeliveryOrPickupDisposition,
  isDineInDisposition,
  isPickupDisposition,
} from 'common/utilities/utils';
import { disableDeliveryOptionsPayWithCashOnArrival } from 'common/utilities/PaymentUtils';

export const getTitlePanel = (type, title) => {
  return (
    <div
      className={`labelContent-checkout-options pl-25px col-sm-4 col-12 ${getTernaryValue(
        isDineInDisposition(type),
        'type-dine-in',
        '',
      )}`}
    >
      <span>{title}</span>
    </div>
  );
};

export const getRadioOptionPanel = params => {
  const { type, checkoutDetails, radioBtnChangeHandler, updateCheckoutDetails } = params;
  return (
    <div
      id='radioButtons'
      className='d-flex flex-column'
      data-testid='option-panel'
      value={checkoutDetails?.userOption}
      onChange={() => radioBtnChangeHandler(checkoutDetails, updateCheckoutDetails)}
    >
      <div className='radioBtns'>
        <input
          type='radio'
          id={CHECKOUT_CONSTANTS?.LEAVE_AT_MY_DOOR}
          name='checkoutOptions'
          value={CHECKOUT_CONSTANTS?.LEAVE_AT_MY_DOOR}
          defaultChecked={
            checkoutDetails?.userParams?.loggedIn && checkoutDetails?.isContactlessFromPastOrder
              ? checkoutDetails?.isContactlessFromPastOrder
              : checkoutDetails?.userOption === CHECKOUT_CONSTANTS?.LEAVE_AT_MY_DOOR
          }
        />
        <label htmlFor={CHECKOUT_CONSTANTS?.LEAVE_AT_MY_DOOR}>
          {
            <>
              <span className='leaveAtMyDoorTitle' tabIndex='0'>
                {translateWithI18Next(
                  getTernaryValue(
                    isDeliveryDisposition(type),
                    TRANSLATE_MAPPING_KEY.LEAVE_AT_MY_DOOR,
                    getTernaryValue(
                      isPickupDisposition(type),
                      TRANSLATE_MAPPING_KEY.WALK_IN_STORE,
                      TRANSLATE_MAPPING_KEY.DINE_IN_STORE,
                    ),
                  ),
                )}
              </span>
              <div className='ml-25px option-note'>
                {translateWithI18Next(
                  getTernaryValue(isDeliveryDisposition(type), TRANSLATE_MAPPING_KEY.LEAVE_AT_MY_DOOR_DESC, ''),
                )}
              </div>
            </>
          }
        </label>
      </div>
    </div>
  );
};

export const dispositionOptionTitle = params => {
  const {
    type,
    cartData,
    kfcToCarCollectionPointCheck,
    checkoutDetails,
    updateCheckoutDetails,
    radioBtnChangeHandler,
  } = params;
  return (
    isDeliveryOrPickupDisposition(type) &&
    kfcToCarCollectionPointCheck(cartData?.availableCollectionPoints, type) && (
      <>
        <div className='radioBtns mt-10px pl-0px pr-0px'>
          <input
            type='radio'
            id={CHECKOUT_CONSTANTS?.HAND_IT_TO_ME}
            name='checkoutOptions'
            value={CHECKOUT_CONSTANTS?.HAND_IT_TO_ME}
            defaultChecked={
              checkoutDetails?.userParams?.loggedIn && checkoutDetails?.isContactlessFromPastOrder
                ? checkoutDetails?.isContactlessFromPastOrder
                : checkoutDetails?.userOption === CHECKOUT_CONSTANTS?.HAND_IT_TO_ME
            }
            onChange={() => radioBtnChangeHandler(checkoutDetails, updateCheckoutDetails)}
          />
          <label htmlFor={CHECKOUT_CONSTANTS?.HAND_IT_TO_ME}>
            {
              <>
                <span className='handItToMe' tabIndex='0'>
                  {translateWithI18Next(
                    getTernaryValue(
                      isDeliveryDisposition(type),
                      TRANSLATE_MAPPING_KEY?.HAND_IT_TO_ME,
                      TRANSLATE_MAPPING_KEY?.KFC_TO_YOUR_CAR,
                    ),
                  )}
                </span>
                <div className='ml-25px option-note'>
                  {translateWithI18Next(
                    getTernaryValue(isDeliveryDisposition(type), '', TRANSLATE_MAPPING_KEY?.KFC_TO_YOUR_CAR_DESC),
                  )}
                </div>
              </>
            }
          </label>
        </div>
      </>
    )
  );
};

export const dispositionOptionInstruction = params => {
  const { type, cartData, kfcToCarCollectionPointCheck, checkoutDetails, updateDispositionOptions } = params;
  return (
    isDeliveryOrPickupDisposition(type) &&
    kfcToCarCollectionPointCheck(cartData?.availableCollectionPoints, type) && (
      <>
        <hr className='handItToMe-hr' />
        <form className='deliveryInstrs mb-3'>
          <textarea
            id='instruction'
            className='textarea'
            data-testid='delivery-instrn'
            name={`${getTernaryValue(
              isDeliveryDisposition(type),
              TRANSLATE_MAPPING_KEY?.DELIVERY_INSTRUCTION,
              TRANSLATE_MAPPING_KEY?.VEHICAL_INFORMATION,
            )}`}
            rows='2'
            placeholder={`${getTernaryValue(
              isDeliveryDisposition(type),
              translateWithI18Next(TRANSLATE_MAPPING_KEY?.DELIVERY_INSTRUCTIONS),
              translateWithI18Next(TRANSLATE_MAPPING_KEY?.VEHICLE_INFORMATION),
            )}`}
            aria-label={`${getTernaryValue(
              isDeliveryDisposition(type),
              translateWithI18Next(TRANSLATE_MAPPING_KEY?.DELIVERY_INSTRUCTIONS),
              translateWithI18Next(TRANSLATE_MAPPING_KEY?.VEHICLE_INFORMATION),
            )}`}
            maxLength='100'
            onChange={updateDispositionOptions}
            value={checkoutDetails?.userInformation?.value}
            onBlur={updateDispositionOptions}
            onFocus={e => (e.target.placeholder = '')}
          />
        </form>
        {getAndCheck(
          checkoutDetails?.userInformation?.error,
          <div id='deliveryInstrs' className='deliveryInstrs-error'>
            <span role='alert' className='deliveryInstrs-error'>
              {checkoutDetails?.userInformation?.errorMessage}
            </span>
          </div>,
        )}
      </>
    )
  );
};

export const dispostionInstructionPayOnArrival = params => {
  const { type, checkoutDetails, updateCheckoutDetails } = params;

  return (
    isDeliveryDisposition(type) &&
    checkoutDetails?.enablePayOnArrival &&
    checkoutDetails?.enablePayByCashOption && (
      <>
        <div className={`d-flex form-checkbox-container form-checkbox-payonarrival`}>
          <input
            type='checkbox'
            className={`common_checkbox`}
            value={checkoutDetails.isClickPayOnArrival}
            onChange={event => updateCheckoutDetails({ isClickPayOnArrival: event.target.checked })}
            data-testid={`pay-on-arrival-checkbox`}
            disabled={disableDeliveryOptionsPayWithCashOnArrival(checkoutDetails)}
            checked={checkoutDetails.isClickPayOnArrival}
            name='checkout-pay-on-arrival'
            id='checkout-pay'
          />
          <label title='title' className='form-check-label' for='checkout-pay'>
            {translateWithI18Next(TRANSLATE_MAPPING_KEY?.PAY_ON_ARRIVAL_CHECKBOX)}
          </label>
        </div>
        <div className='optional-description'>
          {translateWithI18Next(TRANSLATE_MAPPING_KEY?.PAY_ON_ARRIVAL_CHECKBOX_DESCRIPTION)}
        </div>
      </>
    )
  );
};
